/* Manzo Atlas of Italy. Runs once per section, and again when the theme editor reloads it. */
(function () {
function mzaInit(root) {
  const DATA = JSON.parse(root.querySelector('script[data-mza-data]').textContent);
  const BRANDS = DATA.core.brands, CATS = DATA.core.cats, REGIONS = DATA.core.regions;
  const FULL = [0, 0, 1000, 1312];
  const map = root.querySelector('#' + 'mza-map');
  const card = root.querySelector('#' + 'mza-card');
  const $ = id => root.querySelector('#' + id);
  const els = sel => [...root.querySelectorAll(sel)];

  // Theme-editor brand blocks: rename, re-describe, re-logo or hide any brand without touching code
  (DATA.overrides || []).forEach(o => {
    const i = BRANDS.findIndex(x => x.id === o.id); if (i < 0) return;
    if (o.hide) {
      BRANDS.splice(i, 1);
      root.querySelectorAll('#mza-map [data-brand="' + o.id + '"]').forEach(el => el.remove());
      root.querySelector('.mza-row[data-brand="' + o.id + '"]')?.parentElement.remove();
      return;
    }
    const b = BRANDS[i];
    ['name', 'town', 'line', 'address', 'shop', 'keywords'].forEach(k => { if (o[k]) b[k] = o[k]; });
    const cats = (o.cats || '').split(',').map(s => s.trim()).filter(Boolean);
    if (cats.length) b.cats = cats;
    const row = root.querySelector('.mza-row[data-brand="' + o.id + '"]');
    if (row) {
      row.querySelector('.mza-row-name').textContent = b.name;
      row.querySelector('.mza-row-town').textContent = b.town;
      row.querySelector('.mza-row-line').textContent = b.line;
    }
    const g = root.querySelector('#mza-map .mza-logo[data-brand="' + o.id + '"]');
    if (g) {
      g.setAttribute('aria-label', b.everywhere ? b.name + ', sourced across Italy' : b.name + ', ' + b.town);
      if (o.logo) g.querySelector('image').setAttribute('href', o.logo);
    }
  });

  // Theme-editor "Add brand" blocks: a brand new brand in the list, with a pin, line and logo on the map
  (() => {
    const NS = 'http://www.w3.org/2000/svg';
    const ORDER = Object.keys(REGIONS);
    const ord = r => r === 'Across Italy' ? -1 : ORDER.indexOf(r);
    const mk = (tag, attrs, parent) => { const el = document.createElementNS(NS, tag);
      Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v)); if (parent) parent.append(el); return el; };
    // the map is drawn on a straight latitude/longitude grid; these two lines turn a town's coordinates into map points
    const px = lon => 83.33449 * lon - 550.0771, py = lat => -112.13048 * lat + 5286.9346;
    const hsl = hex => { let [r, g, b] = [1, 3, 5].map(i => parseInt(hex.slice(i, i + 2), 16) / 255);
      const mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn;
      let h = 0, s = d ? d / (1 - Math.abs(2 * l - 1)) : 0;
      if (d) h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
      return [(h * 60 + 360) % 360, s * 100, l * 100]; };
    const lineColor = region => {
      const twin = BRANDS.find(b => b.region === region && root.querySelector('#mza-map .mza-dot[data-brand="' + b.id + '"]'));
      if (twin) return root.querySelector('#mza-map .mza-dot[data-brand="' + twin.id + '"]').getAttribute('fill');
      const [h, s] = hsl(REGIONS[region].fill || '#999999'); return 'hsl(' + h.toFixed(0) + ' ' + Math.min(60, s + 15).toFixed(0) + '% 34%)'; };
    let n = root.querySelectorAll('#mza-map .mza-dot').length;
    (DATA.newBrands || []).forEach(o => {
      if (!o.name || !REGIONS[o.region]) return;
      const id = 'new-' + o.id, everywhere = o.region === 'Across Italy';
      const nums = (o.coords || '').match(/-?\d+(?:\.\d+)?/g) || [];
      let lat = parseFloat(nums[0]), lon = parseFloat(nums[1]);
      const pinned = !everywhere && lat > 35 && lat < 47.6 && lon > 6 && lon < 19;
      if (!pinned) { lat = NaN; lon = NaN; }
      const cats = (o.cats || '').split(',').map(s => s.trim()).filter(Boolean);
      const b = { id, name: o.name, region: o.region, line: o.line || '', town: o.town || (everywhere ? 'Across Italy' : ''),
        address: o.address || '', lat, lon, shop: o.shop || '#', cats, keywords: o.keywords || '', logo: o.logo || '' };
      if (everywhere) b.everywhere = true;
      let at = BRANDS.findIndex(x => ord(x.region) > ord(o.region)); if (at < 0) at = BRANDS.length;
      BRANDS.splice(at, 0, b);

      // list row, in a new region group if this region had no brands yet
      let group = [...root.querySelectorAll('.mza-group')].find(g => g.dataset.region === o.region);
      if (!group) {
        group = document.createElement('li'); group.className = 'mza-group'; group.dataset.region = o.region;
        group.innerHTML = '<div class="mza-group-head"><span class="mza-swatch"></span><h2 class="mza-group-name"></h2>'
          + '<span class="mza-group-count"></span></div><ul class="mza-rows"></ul>';
        group.querySelector('.mza-swatch').style.background = REGIONS[o.region].fill;
        group.querySelector('.mza-group-name').textContent = o.region;
        const next = [...root.querySelectorAll('.mza-group')].find(g => ord(g.dataset.region) > ord(o.region));
        next ? next.before(group) : root.querySelector('#mza-groups').append(group);
      }
      const li = document.createElement('li');
      li.innerHTML = '<button class="mza-row" type="button" aria-pressed="false"><span class="mza-row-name"></span>'
        + '<span class="mza-row-town"></span><span class="mza-row-line"></span></button>';
      const row = li.firstChild; row.dataset.brand = id;
      row.querySelector('.mza-row-name').textContent = b.name;
      row.querySelector('.mza-row-town').textContent = b.town;
      row.querySelector('.mza-row-line').textContent = b.line;
      group.querySelector('.mza-rows').append(li);
      if (!pinned) return;

      // pin, ring, leader line and logo tile on the map
      const x = px(lon), y = py(lat), col = lineColor(o.region), i = n++;
      const W = 110, H = 42, d = +o.dist || 60, nudge = +o.nudge || 0;
      let cx = x, cy = y, ex, ey;
      if (o.side === 'left') { cx = x - d - W / 2; cy = y + nudge; ex = cx + W / 2; ey = cy; }
      else if (o.side === 'above') { cx = x + nudge; cy = y - d - H / 2; ex = cx; ey = cy + H / 2; }
      else if (o.side === 'below') { cx = x + nudge; cy = y + d + H / 2; ex = cx; ey = cy - H / 2; }
      else { cx = x + d + W / 2; cy = y + nudge; ex = cx - W / 2; ey = cy; }
      const f = v => v.toFixed(1);
      const defs = map.querySelector('defs') || mk('defs', {}, map);
      const gr = mk('linearGradient', { id: 'lg-' + id, gradientUnits: 'userSpaceOnUse', x1: f(x), y1: f(y), x2: f(ex), y2: f(ey) }, defs);
      [['0', '.95'], ['.55', '.62'], ['1', '.3']].forEach(([off, op]) => mk('stop', { offset: off, 'stop-color': col, 'stop-opacity': op }, gr));
      const mx = (x + ex) / 2, my = (y + ey) / 2, len = Math.hypot(ex - x, ey - y) || 1;
      const qx = mx - (ey - y) / len * len * .12, qy = my + (ex - x) / len * len * .12;
      mk('path', { class: 'mza-leader', style: '--i:' + i, pathLength: '1', 'data-brand': id, stroke: 'url(#lg-' + id + ')',
        d: 'M' + f(x) + ' ' + f(y) + 'Q' + f(qx) + ' ' + f(qy) + ' ' + f(ex) + ' ' + f(ey) }, root.querySelector('#mza-leaders'));
      const dots = root.querySelector('#mza-dots');
      mk('circle', { class: 'mza-ring', 'data-brand': id, cx: f(x), cy: f(y), r: '6.5' }, dots);
      mk('circle', { class: 'mza-dot', style: '--i:' + i, 'data-brand': id, fill: col, cx: f(x), cy: f(y), r: '2.4' }, dots);
      const g = mk('g', { class: 'mza-logo', style: '--i:' + i + ';transform-origin:' + f(ex) + 'px ' + f(ey) + 'px', 'data-brand': id,
        tabindex: '0', role: 'button', 'aria-pressed': 'false', 'aria-label': b.name + (b.town ? ', ' + b.town : '') }, root.querySelector('#mza-logos'));
      mk('rect', { class: 'mza-hit', x: f(cx - W / 2 - 3), y: f(cy - H / 2 - 3), width: W + 6, height: H + 6 }, g);
      mk('rect', { class: 'mza-tile', x: f(cx - W / 2), y: f(cy - H / 2), width: W, height: H, rx: '7', fill: REGIONS[o.region].fill, stroke: col }, g);
      if (b.logo) mk('image', { href: b.logo, x: f(cx - W / 2 + 3), y: f(cy - H / 2 + 3), width: W - 6, height: H - 6, preserveAspectRatio: 'xMidYMid meet' }, g);
      else { const t = mk('text', { x: f(cx), y: f(cy + 5), 'text-anchor': 'middle', fill: col,
          style: 'font: 700 14px var(--display); pointer-events: none' }, g); t.textContent = b.name; }
    });
  })();

  // Theme-editor region blocks: rename a region everywhere, recolor it, and recolor its pins and lines
  const RN = {};
  (DATA.regionOverrides || []).forEach(o => {
    const r = REGIONS[o.id]; if (!r) return;
    if (o.name) RN[o.id] = o.name;
    if (o.fill) r.fill = o.fill;
    BRANDS.filter(b => b.region === o.id).forEach(b => {
      const tile = root.querySelector('#mza-map .mza-logo[data-brand="' + b.id + '"] .mza-tile');
      if (tile && o.fill) tile.setAttribute('fill', o.fill);
      if (o.line) {
        if (tile) tile.setAttribute('stroke', o.line);
        root.querySelectorAll('#lg-' + b.id + ' stop').forEach(s => s.setAttribute('stop-color', o.line));
        root.querySelector('#mza-map .mza-dot[data-brand="' + b.id + '"]')?.setAttribute('fill', o.line);
      }
    });
  });
  const rn = k => RN[k] || k;
  root.querySelectorAll('#mza-map .mza-rlabel').forEach(t => { if (RN[t.dataset.region]) t.textContent = RN[t.dataset.region]; });
  root.querySelectorAll('.mza-group').forEach(g => { if (RN[g.dataset.region]) g.querySelector('.mza-group-name').textContent = RN[g.dataset.region]; });
  const byId = Object.fromEntries(BRANDS.map(b => [b.id, b]));
  const narrow = matchMedia('(max-width: 859.98px)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const S = { brand: null, cat: null, region: null, q: '', zoomOut: false };
  const norm = t => t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/['’]/g, '');
  // search looks only at each brand's own details, so a word matches what that brand actually makes
  const hay = Object.fromEntries(BRANDS.map(b => [b.id, norm([b.name, b.town, b.line, b.region, rn(b.region), b.address, b.keywords || ''].join(' '))]));
  let lastRing = null, lastCard = null;
  const logoSrc = id => map.querySelector('.mza-logo[data-brand="' + id + '"] image')?.getAttribute('href') || (byId[id] && byId[id].logo) || '';
  const plural = (n, w) => n + ' ' + w + (n === 1 ? '' : 's');
  const countIn = region => BRANDS.filter(b => b.region === region).length;

  // Every count on the page comes from BRANDS, so adding or removing a brand updates them all.
  function syncCounts() {
    const pinned = BRANDS.filter(b => !b.everywhere), every = BRANDS.filter(b => b.everywhere);
    const regions = new Set(pinned.map(b => b.region)).size;
    if (!DATA.leadCustom) $('mza-lead').textContent = plural(pinned.length, 'brand') + ' from ' + regions + ' regions, each pinned to the town where it’s made'
      + (every.length ? ', plus ' + every.map(b => b.name).join(' and ') + ', sourced from across Italy. ' : '. ')
      + 'Search by name, pick a logo or a region, or browse by product.';
    els('.mza-chip').forEach(c => {
      const n = c.dataset.cat === 'all' ? BRANDS.length : BRANDS.filter(b => b.cats.includes(c.dataset.cat)).length;
      c.querySelector('.mza-n').textContent = n;
      c.hidden = n === 0;
    });
    els('#mza-map .mza-region').forEach(r => {
      const name = r.dataset.region; if (!REGIONS[name]) return;
      const n = countIn(name);
      r.classList.toggle('mza-has-brands', n > 0);
      // a region opens a card when brands are made there or a brand sources from all of Italy
      r.classList.toggle('mza-clickable', n > 0 || every.length > 0);
      if (n || every.length) { r.setAttribute('tabindex', '0'); r.setAttribute('role', 'button');
        r.setAttribute('aria-label', n ? rn(name) + ', ' + plural(n, 'brand') : rn(name) + ', ' + every.map(b => b.name).join(' and ') + ' sources here'); }
      else { r.removeAttribute('tabindex'); r.removeAttribute('role'); r.removeAttribute('aria-label'); }
    });
  }
  syncCounts();

  function visible() {
    if (S.region) return BRANDS.filter(b => b.region === S.region || b.everywhere);
    let list = S.cat ? BRANDS.filter(b => b.cats.includes(S.cat)) : BRANDS;
    if (S.q) { const words = norm(S.q).split(/\s+/).filter(Boolean); list = list.filter(b => words.every(w => hay[b.id].includes(w))); }
    return list;
  }

  function render(opts = {}) {
    const vis = visible(), visIds = new Set(vis.map(b => b.id));
    const b = S.brand && byId[S.brand];

    // list
    els('.mza-row').forEach(r => {
      r.parentElement.hidden = !visIds.has(r.dataset.brand);
      r.setAttribute('aria-pressed', r.dataset.brand === S.brand ? 'true' : 'false');
    });
    els('.mza-group').forEach(g => {
      const n = vis.filter(x => x.region === g.dataset.region).length;
      g.hidden = n === 0;
      g.querySelector('.mza-group-count').textContent = plural(n, 'brand');
    });
    $('mza-empty').hidden = vis.length > 0;
    $('mza-empty').textContent = S.q ? 'No brands match “' + S.q + '”. Try a brand, a town like Naples, or a product like pasta.'
      : 'Nothing to show here. Choose another region or product.';
    els('.mza-chip').forEach(c => c.setAttribute('aria-pressed', (c.dataset.cat === (S.cat || 'all') && !S.region) ? 'true' : 'false'));
    let status = 'All ' + BRANDS.length + ' brands, north to south';
    if (S.region) { const local = countIn(S.region), every = vis.filter(x => x.everywhere).map(x => x.name).join(' and ');
      status = local ? plural(local, 'brand') + ' from ' + rn(S.region) + (every ? ', plus ' + every : '')
                     : (every ? every + ' sources from ' + rn(S.region) : 'No Manzo brands from ' + rn(S.region) + ' yet'); }
    else if (S.q) status = (vis.length ? plural(vis.length, 'brand') + ' matching' : 'No brands match') + ' “' + S.q + '”' + (S.cat ? ' in ' + CATS.find(c => c.id === S.cat).label.toLowerCase() : '');
    else if (S.cat) status = plural(vis.length, 'brand') + ' for ' + CATS.find(c => c.id === S.cat).label.toLowerCase();
    $('mza-status-text').textContent = status;
    $('mza-status-clear').hidden = !(S.region || S.cat || S.q);
    $('mza-search-clear').hidden = !$('mza-search').value;

    // map
    let onRegions, match;
    if (b) { onRegions = b.everywhere ? new Set([...Object.keys(REGIONS), 'none']) : new Set([b.region]); match = new Set([b.id]); }
    else if (S.region) { onRegions = new Set([S.region]); match = visIds; }
    else if (S.cat || S.q) { onRegions = new Set(vis.map(x => x.region)); match = visIds; }
    const dimming = !!onRegions;
    map.classList.toggle('mza-dimming', dimming);
    map.classList.toggle('mza-gold', !!b && !!b.everywhere);
    els('#mza-map .mza-region, #mza-map .mza-rlabel').forEach(el => el.classList.toggle('mza-is-dim', dimming && !onRegions.has(el.dataset.region)));
    els('#mza-map [data-brand]').forEach(el => {
      const id = el.dataset.brand;
      const near = !!b && id !== b.id && byId[id].region === b.region;
      el.classList.toggle('mza-is-near', near);
      el.classList.toggle('mza-is-dim', dimming && !match.has(id) && !near);
      el.classList.toggle('mza-is-sel', id === S.brand);
      if (el.classList.contains('mza-logo')) el.classList.toggle('mza-is-match', dimming && !b && match.has(id));
    });
    els('#mza-map .mza-logo').forEach(el => el.setAttribute('aria-pressed', el.dataset.brand === S.brand ? 'true' : 'false'));
    if (b && b.id !== lastRing) {
      const ring = map.querySelector('.mza-ring[data-brand="' + b.id + '"]');
      if (ring) { ring.classList.remove('mza-is-sel'); void ring.getBoundingClientRect(); ring.classList.add('mza-is-sel'); }
    }
    lastRing = b ? b.id : null;
    $('mza-hint').hidden = dimming;

    // card
    if (b) fillBrand(b, vis);
    else if (S.region) fillRegion(S.region, vis);
    card.hidden = !(b || S.region);
    const key = b ? b.id : S.region;
    if (!card.hidden && key !== lastCard && opts.animateCard !== false) { card.style.animation = 'none'; void card.offsetWidth; card.style.animation = ''; }
    lastCard = card.hidden ? null : key;

    zoomTo(target());
  }

  function fillBrand(b, vis) {
    $('mza-card-brand').hidden = false; $('mza-card-regionview').hidden = true;
    card.setAttribute('aria-label', b.name);
    $('mza-card-region').textContent = rn(b.region);
    $('mza-card-swatch').style.background = REGIONS[b.region].fill;
    const list = vis.some(x => x.id === b.id) ? vis : BRANDS;
    const i = list.findIndex(x => x.id === b.id);
    $('mza-card-pos').textContent = (i + 1) + ' / ' + list.length;
    const multi = list.length > 1;
    $('mza-prev').hidden = $('mza-next').hidden = $('mza-card-pos').hidden = !multi;
    const src = logoSrc(b.id);
    $('mza-card-logo').parentElement.hidden = !src;
    if (src) $('mza-card-logo').src = src;
    $('mza-card-logo').alt = b.name + ' logo';
    $('mza-card-name').textContent = b.name;
    $('mza-card-line').textContent = b.line;
    $('mza-card-address').textContent = b.address;
    $('mza-card-address').closest('.mza-card-address, p').hidden = !b.address;
    $('mza-card-shop').href = b.shop;
    $('mza-card-shop-text').textContent = 'Shop ' + b.name;
    const also = BRANDS.filter(o => o.id !== b.id && Math.abs(o.lat - b.lat) < 0.01 && Math.abs(o.lon - b.lon) < 0.01);
    $('mza-card-also').hidden = !also.length;
    $('mza-card-also').textContent = also.length ? 'Also made here: ' + also.map(o => o.name).join(', ') : '';
  }

  function fillRegion(name, vis) {
    $('mza-card-brand').hidden = true; $('mza-card-regionview').hidden = false;
    card.setAttribute('aria-label', name);
    $('mza-card-region').textContent = 'Region';
    $('mza-card-swatch').style.background = REGIONS[name].fill;
    $('mza-prev').hidden = $('mza-next').hidden = $('mza-card-pos').hidden = true;
    $('mza-rv-name').textContent = rn(name);
    const local = vis.filter(x => !x.everywhere), every = vis.filter(x => x.everywhere);
    const names = every.map(x => x.name).join(' and ');
    $('mza-rv-count').textContent = local.length ? plural(local.length, 'Manzo brand') + ' made here.' + (every.length ? ' ' + names + ' also sources from here.' : '')
      : every.length ? names + ' sources from ' + rn(name) + '.' : 'No Manzo brands are made here yet.';
    const grid = $('mza-rv-grid'); grid.replaceChildren();
    grid.hidden = !vis.length;
    [...local, ...every].forEach(x => {
      const btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'mza-rv-item'; btn.setAttribute('aria-label', x.name);
      const src = logoSrc(x.id);
      if (src) { const img = document.createElement('img'); img.src = src; img.alt = ''; btn.append(img); }
      else { btn.textContent = x.name; btn.style.font = '700 13px/1.15 var(--display)'; btn.style.textAlign = 'center'; } btn.addEventListener('click', () => pickBrand(x.id, 'mza-card'));
      grid.append(btn);
    });
  }

  // ---------- zoom ----------
  function target() {
    if (S.zoomOut) return FULL;
    let key = null;
    if (S.region && countIn(S.region)) key = S.region;
    else if (S.brand && !byId[S.brand].everywhere) key = byId[S.brand].region;
    if (!key) return FULL;
    let [x, y, w, h] = REGIONS[key].box;
    const min = 300;
    if (w < min) { x -= (min - w) / 2; w = min; }
    if (h < min) { y -= (min - h) / 2; h = min; }
    return fit([x, y, w, h]);
  }
  // Fit a box into the map, leaving room for the card on desktop (a strip on the left or at the bottom, whichever zooms more).
  function fit([x, y, w, h]) {
    const W = map.clientWidth, H = map.clientHeight;
    if (!W || !H) return [x, y, w, h];
    let left = 0, bottom = 0;
    if (!card.hidden && !narrow.matches) {
      ['mza-pos-tr', 'mza-pos-br', 'mza-pos-tl'].forEach(c => card.classList.remove(c));
      const c = card.getBoundingClientRect(), m = map.getBoundingClientRect();
      const sL = Math.min((W - (c.right - m.left + 14)) / w, H / h), sB = Math.min(W / w, (H - (m.bottom - c.top + 14)) / h);
      if (sL >= sB) left = c.right - m.left + 14; else bottom = m.bottom - c.top + 14;
    }
    const base = Math.min(W / 1000, H / 1312);
    const s = Math.min(Math.min((W - left) / w, (H - bottom) / h), base * 3.6);
    const vw = W / s, vh = H / s;
    return [x - left / s - ((W - left) / s - w) / 2, y - ((H - bottom) / s - h) / 2, vw, vh];
  }
  const isFull = t => t.every((v, i) => Math.abs(v - FULL[i]) < 0.5);
  let vb = FULL.slice(), anim = null;
  function zoomTo(t, instant) {
    const zoomed = !isFull(t);
    $('mza-zoom-out').hidden = !zoomed;
    map.classList.toggle('mza-is-zoomed', zoomed);
    if (t.every((v, i) => Math.abs(v - vb[i]) < 0.5)) { placeCard(); return; }
    cancelAnimationFrame(anim);
    const from = vb.slice(), t0 = performance.now(), dur = (reduce.matches || instant) ? 0 : 650;
    map.classList.add('mza-is-zooming');
    const ease = p => p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
    const step = now => {
      const p = dur ? Math.min(1, (now - t0) / dur) : 1, e = ease(p);
      vb = from.map((v, i) => v + (t[i] - v) * e);
      map.setAttribute('viewBox', vb.map(v => v.toFixed(2)).join(' '));
      if (p < 1) anim = requestAnimationFrame(step);
      else { map.classList.remove('mza-is-zooming'); placeCard(); }
    };
    anim = requestAnimationFrame(step);
  }

  // Keep the card off what it describes: try each corner, keep the first that covers nothing important.
  function placeCard() {
    ['mza-pos-tr', 'mza-pos-br', 'mza-pos-tl'].forEach(c => card.classList.remove(c));
    if (card.hidden || narrow.matches || !isFull(vb)) return;
    const ids = S.brand ? [S.brand] : visible().map(b => b.id);
    const keep = ids.flatMap(id => [map.querySelector('.mza-logo[data-brand="' + id + '"] .mza-tile'), map.querySelector('.mza-dot[data-brand="' + id + '"]')]).filter(Boolean)
      .map(el => el.getBoundingClientRect());
    const cost = () => { const c = card.getBoundingClientRect();
      return keep.reduce((s, r) => s + Math.max(0, Math.min(r.right, c.right + 8) - Math.max(r.left, c.left - 8)) * Math.max(0, Math.min(r.bottom, c.bottom + 8) - Math.max(r.top, c.top - 8)), 0); };
    let best = null;
    for (const pos of ['', 'mza-pos-tr', 'mza-pos-br', 'mza-pos-tl']) {
      if (pos) card.classList.add(pos);
      const v = cost();
      if (best === null || v < best.v) best = { pos, v };
      if (pos) card.classList.remove(pos);
      if (v === 0) break;
    }
    if (best.pos) card.classList.add(best.pos);
  }

  // ---------- actions ----------
  function pickBrand(id, from) {
    if (S.brand === id && from !== 'mza-card') { S.brand = null; }
    else {
      S.brand = id;
      if (!visible().some(b => b.id === id)) { S.cat = null; S.region = null; clearSearch(); }
    }
    S.zoomOut = false;
    render();
    if (S.brand && from === 'list' && narrow.matches) {
      root.querySelector('.mza-map-pane').scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
    }
    if (S.brand && from !== 'list' && !narrow.matches) {
      root.querySelector('.mza-row[data-brand="' + id + '"]')?.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'nearest' });
    }
  }
  function pickRegion(name) {
    if (S.region === name && !S.brand) S.region = null;
    else { S.region = name; S.cat = null; S.brand = null; }
    S.zoomOut = false;
    render();
    if (S.region && !narrow.matches) root.querySelector('.mza-group[data-region="' + name + '"]')?.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'nearest' });
  }
  function step(dir) {
    if (!S.brand) return;
    const vis = visible(); const list = vis.some(x => x.id === S.brand) ? vis : BRANDS;
    const i = list.findIndex(x => x.id === S.brand);
    S.brand = list[(i + dir + list.length) % list.length].id;
    S.zoomOut = false;
    render({ animateCard: false });
    if (!narrow.matches) root.querySelector('.mza-row[data-brand="' + S.brand + '"]')?.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'nearest' });
  }
  function back() {
    if (S.brand) S.brand = null;
    else if (S.region) S.region = null;
    S.zoomOut = false;
    render();
  }

  // Hover links a logo with its region (and a region with its logos), so it's clear which belongs where.
  const lit = [];
  const light = els2 => { els2.forEach(el => { if (el) { el.classList.add('mza-hl'); lit.push(el); } }); };
  const unlight = () => { while (lit.length) lit.pop().classList.remove('mza-hl'); };
  els('#mza-map .mza-logo').forEach(g => {
    const b = byId[g.dataset.brand];
    g.addEventListener('pointerenter', e => { if (e.pointerType === 'touch') return;
      light(b.everywhere ? els('#mza-map .mza-region') : [map.querySelector('.mza-region[data-region="' + b.region + '"]'), ...map.querySelectorAll('[data-brand="' + b.id + '"].mza-leader, [data-brand="' + b.id + '"].mza-dot')]); });
    g.addEventListener('pointerleave', unlight);
  });
  els('#mza-map .mza-region.mza-clickable').forEach(r => {
    r.addEventListener('pointerenter', e => { if (e.pointerType === 'touch') return;
      light(BRANDS.filter(b => b.region === r.dataset.region || b.everywhere).flatMap(b => [...map.querySelectorAll('[data-brand="' + b.id + '"]:is(.mza-logo, .mza-leader, .mza-dot)')])); });
    r.addEventListener('pointerleave', unlight);
  });
  els('#mza-map .mza-logo').forEach(g => {
    g.addEventListener('click', e => { e.stopPropagation(); pickBrand(g.dataset.brand, 'mza-map'); });
    g.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pickBrand(g.dataset.brand, 'mza-map'); } });
  });
  els('#mza-map .mza-region').forEach(r => {
    const name = r.dataset.region;
    if (!REGIONS[name]) return;
    r.addEventListener('click', e => { e.stopPropagation(); pickRegion(name); });
    r.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pickRegion(name); } });
  });
  map.querySelector('.mza-sea-hit').addEventListener('click', () => { if (S.brand || S.region) { S.brand = null; S.region = null; S.zoomOut = false; render(); } });
  els('.mza-row').forEach(r => r.addEventListener('click', () => pickBrand(r.dataset.brand, 'list')));
  els('.mza-chip').forEach(c => c.addEventListener('click', () => {
    const id = c.dataset.cat === 'all' ? null : c.dataset.cat;
    S.cat = (S.cat === id && id) ? null : id; S.region = null; S.zoomOut = false;
    if (S.brand && !visible().some(b => b.id === S.brand)) S.brand = null;
    render();
  }));
  $('mza-status-clear').addEventListener('click', () => { S.cat = null; S.region = null; clearSearch(); S.zoomOut = false; render(); });
  // search: filters the list and highlights matching logos as you type; Enter opens the first match
  function clearSearch() { S.q = ''; $('mza-search').value = ''; }
  $('mza-search').addEventListener('input', () => {
    S.q = $('mza-search').value.trim(); S.region = null; S.zoomOut = false;
    if (S.brand && !visible().some(b => b.id === S.brand)) S.brand = null;
    render({ animateCard: false });
  });
  $('mza-search').addEventListener('keydown', e => {
    if (e.key === 'Enter') { const first = visible()[0]; if (first) { e.preventDefault(); pickBrand(first.id, 'list'); } }
    if (e.key === 'Escape') { e.stopPropagation(); if ($('mza-search').value) { clearSearch(); render(); } else $('mza-search').blur(); }
  });
  $('mza-search-clear').addEventListener('click', () => { clearSearch(); render(); $('mza-search').focus(); });
  $('mza-prev').addEventListener('click', () => step(-1));
  $('mza-next').addEventListener('click', () => step(1));
  $('mza-card-close').addEventListener('click', back);
  $('mza-zoom-out').addEventListener('click', () => { S.zoomOut = true; zoomTo(FULL); });
  document.addEventListener('keydown', e => {
    if (!root.isConnected) return;
    if (e.target.closest && e.target.closest('input, textarea, select')) return;
    if (e.key === '/' && !e.metaKey && !e.ctrlKey) { e.preventDefault(); $('mza-search').focus(); return; }
    if (e.key === 'Escape' && (S.brand || S.region)) back();
    if (S.brand && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) { e.preventDefault(); step(e.key === 'ArrowRight' ? 1 : -1); }
  });
  addEventListener('resize', () => { if (!root.isConnected) return; const t = target(); vb = t; map.setAttribute('viewBox', t.join(' ')); zoomTo(t, true); });

  // #brand-id in the link opens that brand
  const start = decodeURIComponent(location.hash.slice(1));
  if (byId[start]) { S.brand = start; }
  // One-time opening: lines draw from each town out to its logo, north to south. Skipped for reduced motion or a deep link.
  if (!S.brand && !reduce.matches) {
    map.classList.add('mza-intro');
    const end = () => map.classList.remove('mza-intro');
    setTimeout(end, 2200);
    ['pointerdown', 'keydown'].forEach(t => addEventListener(t, end, { once: true }));
  }
  render();
 
}

function boot(scope) {
  (scope || document).querySelectorAll('[data-mza-atlas]').forEach(r => { if (!r.__mza) { r.__mza = true; mzaInit(r); } });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot()); else boot();
document.addEventListener('shopify:section:load', e => boot(e.target));
})();